import React from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { space, color } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Text from 'theme/text';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${themeGet('colors.primary_200')};

  ${space}

  & > a {
    text-decoration: none;
  }
`;

const TabBtn = styled.button`
  border-radius: 8px;
  ${color}
  ${space}
`;

const HorizontalDivider = styled.div`
  width: 2px;
  height: 34px; /* Altezza adeguata per stare tra i bottoni */
  background-color: ${themeGet('colors.primary_200')};
  margin: 0 8px; /* Spazio tra gli elementi */
`;

function SubMenu({ activeKey, options }) {
  const isConfirmed = options.length > 0 && options[1].key === "confirmed";

  return (
    <Wrapper py="s" px="l">
      {options.map((option, index) => {
        const isSecondWithOnClick = index === 1 && option.onClick;
        const nextOptionExists = index < options.length - 1;

        return (
          <React.Fragment key={option.key}>
            {!option.onClick ? (
              <Link href={option.href} key={option.key}>
                <a className="link">
                  <TabBtn
                    type="button"
                    py="s"
                    px="m"
                    bg={activeKey === option.key ? 'primary_100' : 'transparent'}
                  >
                    <Text
                      fontSize="h3"
                      lineHeight="h3"
                      fontWeight="medium"
                      color={
                        activeKey === option.key
                          ? 'primary_500'
                          : option.color
                            ? option.color
                            : 'grey_400'
                      }
                      textAlign="center"
                    >
                      {option.title}
                    </Text>
                  </TabBtn>
                </a>
              </Link>
            ) : (
              <TabBtn
                type="button"
                py="s"
                px="m"
                bg={
                  activeKey === option.key
                    ? 'primary_100'
                    : option?.bgColor
                      ? option?.bgColor
                      : 'transparent'
                }
                onClick={option.onClick}
              >
                <Text
                  fontSize="h3"
                  lineHeight="h3"
                  fontWeight="medium"
                  color={
                    activeKey === option.key
                      ? 'primary_500'
                      : option?.color
                        ? option?.color
                        : 'grey_400'
                  }
                  textAlign="center"
                >
                  {option.title}
                </Text>
              </TabBtn>
            )}

            {/* Inserisce il divider solo se la prima opzione NON è "aggregated_data" */}
            {isSecondWithOnClick && nextOptionExists && isConfirmed && <HorizontalDivider />}
          </React.Fragment>
        );
      })}
    </Wrapper>
  );
}

export default SubMenu;